import { ConstanteGlobal } from "../config/constanteGlobal";
import { ModeloSazonalidade } from "../models/sazonalidade";
import { ModeloSopInventory } from "../models/sopInventory";

import { Repositorio } from "./repositorio";

export class FiltroSopInventory {
  editados = false;
  flg_aberto = false;
  num_nivel = 0;

  dth_inicio?: Date | null;
  dth_fim?: Date | null;

  cod_business_unit?: string;
  cod_industrial_plant?: string;
  cod_product?: string;
  cod_product_family?: string;
  resale = false;


  cod_linha_produto_capitao?: string;
  cod_familia_subgrupo_produto_capitao?: string;
  cod_gerencia?: string;
  cod_acabamento?: string;
  cod_temperatura?: string;
  cod_mercado?: string;
  cod_tipo_produto?: string;
  cod_produto_capitao?: string;
  cod_usuario?: string;

  value?: string = "Quantity";
  constructor() {
    const today = new Date();
    this.dth_inicio = new Date(today.getFullYear(), today.getMonth() - 12, 1); // 1 ano atrás
    this.dth_fim = new Date(today.getFullYear(), today.getMonth() + 3, 1);    // 3 meses à frente
  }

}

export class RepositorioSopInventory extends Repositorio<ModeloSopInventory> {
  constructor() {
    super(ConstanteGlobal.SOP_INVENTORY);
  }


  atualizarValor(des_atributo: string, des_valor: string, modelo: ModeloSopInventory) {
    return this.api.post(this.nomeRepositorio + "_atualizar_valor", { des_atributo, des_valor, ...modelo }).then((res) => {
      return res.data;
    });
  }

  getCard(filtro: FiltroSopInventory) {
    return this.api.post(this.nomeRepositorio + "_cards", filtro).then((res) => {
      return res.data;
    });
  }
  getShareRegion(filtro: FiltroSopInventory) {
    return this.api.post(this.nomeRepositorio + "_share_by_region", filtro).then((res) => {
      return res.data;
    });
  }
  getKpis(filtro: FiltroSopInventory) {
    return this.api.post(this.nomeRepositorio + "_kpis", filtro).then((res) => {
      return res.data;
    });
  }
  getForecast(filtro: FiltroSopInventory) {
    return this.api.post(this.nomeRepositorio + "_forecast", filtro).then((res) => {
      return res.data;
    });
  }
  getPlantInventoryClass(filtro: FiltroSopInventory) {
    return this.api.post(this.nomeRepositorio + "_plant_inventory_class", filtro).then((res) => {
      return res.data;
    });
  }

}
